import { CrowdfundingProject } from '@/components/shared/types';

export const crowdfundingCampaigns: CrowdfundingProject[] = [
  {
    id: 'playground-equipment',
    title: 'New Playground Equipment',
    description:
      'Safe, modern playground equipment for children of all ages. This project will transform our community playground into a safer, more engaging space for children to play and develop.',
    location: 'Community Park',
    category: 'infrastructure',
    currentAmount: 12450,
    goalAmount: 25000,
    supporterCount: 38,
    supporters: 38,
    deadline: new Date(Date.now() + 25 * 24 * 60 * 60 * 1000),
    status: 'active' as const,
    creator: {
      name: 'Sarah Johnson',
      title: 'Community Safety Coordinator',
      avatar: '/avatars/sarah-johnson.jpg',
      projectsCreated: 3,
      totalRaised: '$45,000',
    },
    media: [
      {
        type: 'image' as const,
        url: 'https://images.unsplash.com/photo-1596997000103-e597b3ca50df?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2274',
        alt: 'Current playground state',
      },
    ],
  },
  {
    id: 'community-garden',
    title: 'Community Garden Expansion',
    description:
      'Expand our organic community garden with new plots and irrigation system. This project will provide fresh, healthy food for more families while building community connections.',
    location: 'North Side Community Center',
    category: 'environment',
    currentAmount: 3200,
    goalAmount: 8000,
    supporterCount: 22,
    supporters: 22,
    deadline: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000),
    status: 'active' as const,
    creator: {
      name: 'Michael Green',
      title: 'Garden Committee Chair',
      avatar: '/avatars/michael-green.jpg',
      projectsCreated: 2,
      totalRaised: '$15,000',
    },
    media: [
      {
        type: 'image' as const,
        url: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=500',
        alt: 'Current garden state',
      },
    ],
  },
];
